export default __webpack_public_path__ + "locales/pl/FormGallery.json?hash=20d6f09c176816d330a52d4186fc4b3d";